import { Component, computed, inject } from '@angular/core';
import { isFlutterWebView, readSafeAreaInset } from '../services/flutter-webview';
import { V3ChatService } from '../services/v3-chat';

// Flutter WebView only: the floating sparkle button. On web V3ChatCard is the entry point (a fixed
// button would sit at the bottom of the content-sized iframe). See CLAUDE.md here.
@Component({
  selector: 'app-v3-chat-trigger',
  standalone: true,
  templateUrl: './v3-chat-trigger.html',
  styleUrl: './v3-chat-trigger.scss',
})
export class V3ChatTrigger {
  readonly chat = inject(V3ChatService);
  private readonly flutter = isFlutterWebView();
  readonly bottomPx = 16 + readSafeAreaInset('safeAreaBottom');

  readonly visible = computed(() => this.chat.isAvailable() && this.flutter);

  open(event: Event): void {
    this.chat.open(event.currentTarget as HTMLElement);
  }
}
